// extracted by mini-css-extract-plugin
export default {"containerModal":"AssignDeviceModal_containerModal__oVWtS","label":"AssignDeviceModal_label__p3Bp5"};